// extracted by mini-css-extract-plugin
export default {"smoothly_appear":"card-info_smoothly_appear__gBEq4","smoothly-appear":"card-info_smoothly-appear__IZQ8e"};